import { BillingTier } from '@zeus/index'

/**
 * Les paliers qu'on choisit, dans l'ordre croissant : celui des listes de choix et
 * des comparaisons. Sans `CUSTOM` : « sur devis » est désormais le mode géré par
 * Studeva, qui se pose à part (#349).
 */
export const BILLING_TIERS = [
  BillingTier.FREE,
  BillingTier.S,
  BillingTier.M,
  BillingTier.L,
  BillingTier.XL,
]
